import gql from 'graphql-tag'

/* Query que obtiene la información del evento para el checkout */
const CHECKOUT_INFORMATION = gql`
query CheckoutInformation($id: String!) {
    checkoutInformation(id: $id) {
    id
    freeEvent
    estatus
    installments
    totalBreakdown
    productsPerOrder
    modality
    extraFields {
      name
      formattedName
      description
      fieldType
      options
      required
    }
    tickets {
      id
      name
      price
      productType
      accessType
      estatus
      inventory {
        inventoryType
        inventoryEstatus
        quantity
        sold
      }
    }
    organizer {
      id
    }
    contactDetails {
      email
      tel
    }
    haveCoupons
    hideCompany
	  hidePhone
    offerBilling
    quantityOfCourtesies
    courtesy
    coupons {
      id
      name
      percentOff
      maxRedemptions
    }
    paymentMethods {
      name
      icon
    }
    attendeeEmail
    attendeeWithPassword
  }
}`

/* Query que obtiene la información de las ordenes del organizador*/
const ORGANIZER_ORDER_INFORMATION = gql`
query OrganizerOrderInformation {
  organizerOrders {
    createdAt
    id
    total
    orderStatus
    billingInformation {
      razonSocialONombreFiscal
      rfc
      usoDelCfdi
      formaDePago
      metodoDePago
      email
      address
      zipCode
    }
    attendeeInformation {
      companyName
      tel
    }
    paymentInformation {
      name
      lastName
      email
      paymentType
    }
    eventInformation {
      id
      name
      organizer {
        companyName
      }
    }
  }
}
`

/* Query que obtiene los boletos de los eventos disponibles de una organización */
const TICKETS_INVENTORY = gql`
query TicketsInventory {
  ticketsInventory{
      id
      name
      productType
      price
      event {
        name
      }
      inventory {
        quantity
        inventoryType
        sold
        inventoryEstatus
      }
    }
}
`

export { CHECKOUT_INFORMATION, ORGANIZER_ORDER_INFORMATION, TICKETS_INVENTORY }